export const HEADER_EMULATED_USER_BUN = 'emulated-user-bun';
export const USER_PROJECT_ID = 'user-project-id';
export const FLATLIST_LIST_ITEMS = 20;
export const MEDIA_AUTH_COOKIE_NAME = 'Authorization';
export const TOOL_TYPES = ['Individual', 'Equipment', 'Bulk'];
export const CONSUMABLE_TYPES = ['Consumables'];
